import {Component} from '@angular/core';
import {ActivatedRoute, Router, } from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {ModalService} from "app/views/modal/base_modal.component";
import {HelperService} from "app/lib/helper.service";
import {getSiteStatusStyle, parseDate} from "../../lib/lib";
import {ChartParams} from "../../views/chart/chart.component";
import {FilterParams} from "../../models/filter_form.model";
import { BillingService2 } from "../../billing/billing.service";

@Component({
	selector: 'before_paid',
	templateUrl: './before_paid.component.html',
})
export class BeforePaidComponent extends BaseComponent {
	currentPage: number = 1;
	totalPages: number = 0;
	pages: string[] = [''];
	links = [];
	stats: any[] = [];
	sort: any = {'date_create': 'desc'};
	typeDateList: string[] = ['dateCreate', 'datePublished', 'created', 'subject', 'age'];
	typeDate: string = 'dateCreate';
	loadingInProgress: boolean = false;
	baseUrl: string = this.router.url.split('?')[0];
	totalCount: number = 0;
	filterCount: number = 0;

	chartData = new ChartParams({
		chartValue: 'absolute'
	});
	
	public dontLoad: any = {};

	addFilterParams = {
		userType: 'user',
		dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated'],
		dateType: 'dateSiteCreated',
		dateFilterParams: {
			dateSiteCreated: {
				start: '01-04-2018',
				end: parseDate().format('DD-MM-YYYY'),
				type: 'all'
			}
		}
	};

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public http: HttpClient,
		public helper: HelperService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
	}

	async ngOnInit() {
		super.ngOnInit();
	}

	async getData() {
		await this.getChart();
	}

	async getChart(params?: FilterParams) {
		if (this.dontLoad.chart) return true;

		this.chartData.showLoader();
		this.chartData.options.chartValue = 'absolute';

		const { charts, categories, } = await this.service2.beforePaid.barChart(
			this.filter.getCopyFilterParams(params)
		).toPromise();
		
		this.chartData.data = charts;

		this.chartData.setOptions({
			title: this.translate.__A('common.The count visits of tariffs page before paid'),
			type: 'bar',
			grid: {
				y: {
					lines: [{value: 0}]
				}
			},
			axis: {
				x: {
					type: 'category',
					categories: categories,
				}
			},
			legend: {
				show: false
			}
		});

		this.chartData.hideLoader();
	}

	public getSiteStatusStyle = getSiteStatusStyle;
}
